import Tree from './Tree';
import TreeNode from './TreeNode';
Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;



// WEBPACK FOOTER //
// ./ext/tree/src/index.js